import { TRANSLATION_KEYS as EDITOR_TRANSLATION_KEYS } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/translations'

import { TRANSLATION_KEYS } from '../../configs/translations'
import { DashboardChartMeasure, DashboardGroupBy } from '../../model/types'

import { TListGroupBy, TListMeasure } from './models'

export const LIST_GROUP_OPTIONS: { key: TListGroupBy; label: string }[] = [
  {
    key: DashboardGroupBy.StrategicInitiative,
    label: TRANSLATION_KEYS.listView.groupBy.strategicInitiative,
  },
  {
    key: DashboardGroupBy.BusinessPriority,
    label: TRANSLATION_KEYS.listView.groupBy.businessPriority,
  },
  { key: DashboardGroupBy.BusinessUnit, label: TRANSLATION_KEYS.listView.groupBy.businessUnit },
  { key: DashboardGroupBy.Period, label: TRANSLATION_KEYS.listView.groupBy.period },
  { key: DashboardGroupBy.Status, label: TRANSLATION_KEYS.listView.groupBy.status },
  { key: 'none', label: TRANSLATION_KEYS.listView.noGrouping },
]
export const LIST_MEASURE_OPTIONS: { key: TListMeasure; label: string }[] = [
  {
    key: DashboardChartMeasure.Goal,
    label: EDITOR_TRANSLATION_KEYS.keyInitiativeEditor.goalFieldGroup.runRateMode,
  },
  {
    key: DashboardChartMeasure.Incremental,
    label: EDITOR_TRANSLATION_KEYS.keyInitiativeEditor.goalFieldGroup.incrementalMode,
  },
  {
    key: 'no-sales-target',
    label: EDITOR_TRANSLATION_KEYS.keyInitiativeEditor.goalFieldGroup.noSalesTargetMode,
  },
  { key: DashboardChartMeasure.Count, label: TRANSLATION_KEYS.listView.countMeasure },
]
export const getListGroupLabel = (groupBy: TListGroupBy): string =>
  LIST_GROUP_OPTIONS.find((option) => option.key === groupBy)?.label ??
  TRANSLATION_KEYS.listView.noGrouping
export const getListMeasureLabel = (measure: TListMeasure): string =>
  LIST_MEASURE_OPTIONS.find((option) => option.key === measure)?.label ??
  TRANSLATION_KEYS.listView.countMeasure
